/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.skipper-parent', {
            // use a parent state to cache the levels etc.
            parent: 'board',
            url: '/board',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            resolve: {
                skipperLevels: ['$http', function($http) {
                    return $http.get('api/board/skipper-level-holders/list');
                }],
                currentProfile: ['PrincipalProfile', function(PrincipalProfile) {
                    return PrincipalProfile.identity(false);
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipper');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.skipper', {
            parent: 'board.skipper-parent',
            url: '/skipper?page&pageSize&sort&matchAny&levels&query&loadQuery',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT'],
                pageTitle: 'askApp.skipper.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/skipper/skippers.html',
                    controller: 'BoardSkipperController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                matchAny: {
                    value: 'true',
                    squash: true
                },
                levels: {
                    value: '',
                    squash: true
                },
                pageSize: {
                    value: '20',
                    squash: true
                },
                filterOpen: {
                    value: false,
                    squash: true
                },
                query: {
                    value: '',
                    squash: true
                },
                loadQuery: {
                    value: 'false',
                    squash: true
                },
                queryOpen: {
                    value: false,
                    squash: true
                },
                queryInfoOpen: {
                    value: false,
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        matchAny: $stateParams.matchAny === 'true',
                        levels: $stateParams.levels.split(','),
                        pageSize: $stateParams.pageSize,
                        filterOpen: $stateParams.filterOpen,
                        query: $stateParams.query,
                        loadQuery: $stateParams.loadQuery === 'true',
                        queryOpen: $stateParams.queryOpen,
                        queryInfoOpen: $stateParams.queryInfoOpen
                    };
                }]
            }
        })
        .state('board.skipper.edit', {
            parent: 'board.skipper',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'skipperLevels', function($stateParams, $state, $uibModal, skipperLevels) {
                $uibModal.open({
                    templateUrl: 'app/board/skipper/skipper-dialog.html',
                    controller: 'BoardSkipperDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('profile');
                            return $translate.refresh();
                        }],
                        skipperLevels: skipperLevels,
                        entity: ['Skipper', function(Skipper) {
                            return Skipper.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.skipper', null, { reload: 'board.skipper' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.skipper.mail', {
            parent: 'board.skipper',
            url: '/mail',
            data: {
                authorities: ['ROLE_SKIPPER_MANAGER', 'ROLE_BOARD', 'ROLE_BOAT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'pagingParams', 'skipperLevels', function($stateParams, $state, $uibModal, pagingParams, skipperLevels) {
                $uibModal.open({
                    templateUrl: 'app/board/skipper/skipper-send-mail.html',
                    controller: 'SkipperDialogSendMailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        pagingParams: pagingParams,
                        skipperLevels: skipperLevels
                    }
                }).result.then(function() {
                    $state.go('board.skipper', null, { reload: 'board.skipper' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
